import { Component, Inject, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'; // Importación actualizada
import { Router, RouterModule } from '@angular/router';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { SessionServiceService } from 'src/app/services/session-service.service';

export interface DialogData {
  titlePass: string;
  mnsjPass: string;
  icon2: string;
  href: string;
}

@Component({
    selector: 'app-pass-box',
    templateUrl: './pass-box.component.html',
    styleUrls: ['./pass-box.component.scss'],
    providers: [RouterModule],
    standalone: false
})
export class PassBoxComponent {
  private configService = inject(ConfigurationService);

  constructor(
    private route: Router, 
    public _session: SessionServiceService,
    public dialogRef: MatDialogRef<PassBoxComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) { 
    dialogRef.disableClose = true; // Este comportamiento sigue siendo el mismo
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
